import * as service from "../../Service/Report.service";
import { mapGetters } from "vuex";
export default {
  name: "DateFilter",
  data() {
    return {
      filtersUnderFinancialYear: [],
      dateFilterList: [],
      startYear: 2019,
      startMonth: "Jan",

      FinancialYearList: [],
      selectedFinancialYear: ""
    };
  },
  async mounted() {
    await this.generateDateFilter();
  },
  computed: {
    disablePreviousPeriod() {
      var index = this.filtersUnderFinancialYear.findIndex(
        x => x.MonthName == this.getCurrentFilters.MonthName
      );
      if (index == this.filtersUnderFinancialYear.length - 1) {
        return true;
      }
      return false;
    },
    disableNextPeriod() {
      var index = this.filtersUnderFinancialYear.findIndex(
        x => x.MonthName == this.getCurrentFilters.MonthName
      );
      if (index == 0) {
        return true;
      }
      return false;
    },
    ...mapGetters(["getFilterPeriod", "getFinancialYear", "getCurrentFilters"])
  },
  methods: {
    async generateDateFilter() {
      var result = await service.getReportFilters();
      if (result.error == false) {
        this.dateFilterList = result.data;
        this.FinancialYearList = [
          ...new Set(result.data.map(x => x.FinancialYear))
        ];

        this.changeFinancialYear(this.FinancialYearList[0]);
      }
    },
    changeFinancialYear(financialYear) {
      this.selectedFinancialYear = financialYear;
      this.filtersUnderFinancialYear = this.dateFilterList.filter(
        x => x.FinancialYear == this.selectedFinancialYear
      );

      // this.$store.commit(
      //   "setFinancialYear",
      //   this.filtersUnderFinancialYear[0].FinancialYear
      // );

      // this.$store.commit(
      //   "setFilterPeriod",
      //   this.filtersUnderFinancialYear[0].MonthName
      // );

      this.$store.commit("setFilter", this.filtersUnderFinancialYear[0]);
    },
    previousPeriod() {
      var index = this.filtersUnderFinancialYear.findIndex(
        x => x.MonthName == this.getCurrentFilters.MonthName
      );

      this.$store.commit(
        "setFilter",
        this.filtersUnderFinancialYear[index + 1]
      );
      // this.$store.commit("setFilterPeriod", this.dateFilterList[index + 1]);
    },
    nextPeriod() {
      var index = this.filtersUnderFinancialYear.findIndex(
        x => x.MonthName == this.getCurrentFilters.MonthName
      );

      this.$store.commit(
        "setFilter",
        this.filtersUnderFinancialYear[index - 1]
      );
    },
    setCurrentPeriod(index) {
      this.$store.commit("setFilter", this.filtersUnderFinancialYear[index]);
    }
  }
};
